import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Logo } from './Logo'

import type { FC, PropsWithChildren, ReactNode } from 'react'

type Props = {
  title?: string | ReactNode
}

export const DesktopHeader: FC<PropsWithChildren<Props>> = ({ title, children }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'header' })
  return (
    <div className="hidden h-15 w-full items-center justify-between px-4 lg:flex">
      <div className="flex h-6 flex-shrink-0 items-center justify-between">
        <Link to="/">
          <Logo />
        </Link>
        <a
          href="#main-content"
          className="kui-btn sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:px-6 focus:py-2"
        >
          {t('goto_main_content')}
        </a>
      </div>

      {title && <div className="flex flex-grow justify-center">{title}</div>}

      <div className="flex flex-shrink-0 justify-end">
        {children}
      </div>
    </div>
  )
}
